<template>
  <div>
    <transition name="slide-fade">
      <v-card v-if="questionsList.length" class="mt-3 mb-3" flat color="">
        <v-card-text
          class="pt-2 pb-2"
          :class="[headerClass.length > 0 ? 'pl-0 pr-0' : '']"
        >
          <v-expansion-panels v-model="QuestionPanelSeq">
            <draggable
              v-model="questionsList"
              group="questions"
              handle=".questions-drag-icon"
              style="width: 100%"
            >
              <a-expansion-panel
                v-for="(question, index) in questionsList"
                :key="question.id"
                class="mb-2 mt-2 question-panel"
                :data-question="index"
                :class="headerClass"
              >
                <v-expansion-panel-header
                  class="pt-1 pb-1"
                  disable-icon-rotate
                  color="appBarT"
                >
                  <template v-slot:default="{ open }">
                    <v-row no-gutters justify="start">
                      <v-col cols="1" md="1">
                        <v-icon small color="white" class="questions-drag-icon"
                          >mdi-cursor-move</v-icon
                        >
                      </v-col>
                      <v-col cols="1">
                        <span v-if="open" key="0">
                          <a-chip
                            small
                            color="Neutral"
                            style="
                              border: 1px solid var(--v-secondary-base) !important;
                            "
                          >
                            {{ `${$t("poll.lblQuestion")} ${index + 1}` }}
                          </a-chip>
                        </span>
                        <span v-else key="1">
                          <a-chip
                            small
                            color="Neutral"
                            style="
                              border: 1px solid var(--v-secondary-base) !important;
                            "
                          >
                            {{ `${$t("poll.lblQuestion")} ${index + 1}` }}
                          </a-chip>
                        </span>
                      </v-col>
                    </v-row>
                  </template>
                  <template v-slot:actions>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          color="grey"
                          dark
                          icon
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon v-if="QuestionPanelSeq == index"
                            >mdi-menu-up
                          </v-icon>
                          <v-icon v-else>mdi-menu-down </v-icon>
                        </v-btn>
                      </template>
                      <span v-if="QuestionPanelSeq == index">{{
                        $t("lblCollapse")
                      }}</span>
                      <span v-else>{{ $t("lblExpand") }}</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="isQuestionAttended(question)">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          small
                          color="grey"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="onDeleteQuestion(question.id)"
                          dark
                          icon
                          v-if="isQuestionAttended(question)"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("poll.tipDelete") }}</span>
                    </v-tooltip>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <component
                    v-if="loadTypeComponent(question.type)"
                    :is="loadTypeComponent(question.type)"
                    :value="question"
                    :responseQuestion="responseQuestion"
                  ></component>
                </v-expansion-panel-content>
              </a-expansion-panel>
            </draggable>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </transition>
    <confirm-dialog ref="confirmDelete" />
  </div>
</template>

<script>
import typeComponents from "../poll/components/index";
import draggable from "vuedraggable";
import { mapGetters, mapMutations, mapState } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";

export default {
  name: "QuestionsPanel",
  components: { draggable, ConfirmDialog },
  props: {
    value: {
      type: [Object, Array],
      default: () => [],
    },
    panel: Number,
    maxWidth: {
      type: String,
      default: "80%",
    },
    id: {
      type: String,
      default: "",
    },
    headerClass: {
      type: String,
      default: "a-expansion-panel-pale-blue",
    },
  },
  data() {
    return {
      questionPanel: 0,
      stringLength: 180
    };
  },
  watch: {
    questionsList() {
      this.questionPanel =
        this.questionsList.length > 0 ? this.questionsList.length - 1 : 0;
    },
  },
  mounted() {
    this.emitInterface();
  },
  computed: {
    ...mapState({
      surveyDetails: (state) => state.poll.surveyDetails,
      surveyResponseResult: (state) => state.poll.surveyResponseResult,
    }),
    ...mapGetters({
      isSurveyExpired: "poll/isSurveyExpired",
    }),
    responseQuestion() {
      const questions = [];
      if(this.surveyResponseResult && this.surveyResponseResult.length > 0){
          this.surveyResponseResult.forEach((item) => {
          item.questionAnswers.forEach((ques) => {
            if (ques.answer) {
              questions.push({
                questionId: ques.questionId,
                answer: ques.answer,
              });
            }
          });
        });
      }
      
      return questions;
    },
    questionsList: {
      get() {
        if (this.id == "") {
          return this.surveyDetails.questions;
        }
        return this.surveyDetails.questions.filter(
          (s) => s.sectionId === this.id
        );
      },
      set(value) {
        if (this.id === "") {
          this.surveyDetails.questions = value;
        } else {
          let questions = this.surveyDetails.questions.filter(
            (s) => s.sectionId != this.id
          );
          value.forEach((element) => {
            questions.push(element);
          });
          this.surveyDetails.questions = questions;
        }
      },
    },
    PanelSeq: {
      get() {
        return this.panel;
      },
      set(value) {
        this.$emit("update:panel", value);
      },
    },
    QuestionPanelSeq: {
      get() {
        return this.questionPanel;
      },
      set(value) {
        this.questionPanel = value;
      },
    },
  },
  methods: {
    ...mapMutations({
      deleteSurveyQuestion: "poll/DELETE_SURVEY_QUESTION",
    }),
    loadTypeComponent,
    onDeleteQuestion,
    ConfirmDelete,
    openPanel,
    isQuestionAttended,
    ellipsis,
    isEllipsis,
    emitInterface() {
      this.$emit("interface", {
        openPanel: (seq) => this.openPanel(seq),
      });
    },
  },
};

function isQuestionAttended(question) {
  const id = question.id;
  if (this.isSurveyExpired) {
    return false;
  }
  if (question.type !== "likert") {
    return !this.responseQuestion.some(
      (r) => r.questionId === id && r.answer !== null
    );
  } else {
    const result = this.responseQuestion.find((item) => item.questionId === id);
    if (result) {
      return !result.answer.some((obj) => obj.value !== null);
    }else{
      return true
    }
  }
}
function openPanel(seq) {
  this.QuestionPanelSeq = Number(seq);
}
async function onDeleteQuestion(id) {
  const answer = await this.ConfirmDelete();
  if (answer) {
    await this.deleteSurveyQuestion(id);
  }
}

function loadTypeComponent(type) {
  return typeComponents[type] || null;
}

function ellipsis(string) {
  return  this.isEllipsis(string) ? string.substring(0, this.stringLength) + "..." : string;
}

function isEllipsis(string) {
  return  String(string).length > this.stringLength;
}

async function ConfirmDelete() {
  if (
    await this.$refs.confirmDelete.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}
</script>

<style scoped>
.questions-drag-icon {
  color: rgba(white, 0.35);
  cursor: move;
  margin-right: 0.8rem;
}
.question-title{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>